import * as React from "react";
import {Video} from "@models/video-content";
import { Rate , Table, Button, Icon, Tooltip} from "antd";
import {FormattedMessage, intlShape} from "react-intl";
import './index.scss'
import {getFormattedPrice} from '@utils';
import {PaymentGatewayOptions} from "../../../models/paymentGateway";
import {NavLink} from "react-router-dom";


type Props = {
  data: Video[];
  loading: boolean;
  deleteFn: (item: Video) => void;
  intl: intlShape.isRequired;
  currentPage: number;
};

const ReportList: React.FC<Props> = props => {
  const {data, loading} = props;
  
  const columns = [
    {
      title: <FormattedMessage id="app.index" defaultMessage={`Index`}/>,
      width: 30,
      dataIndex: "id",
      key: "id",
      render: (a, b, i) => <span>{i + 1 }</span>
    },
    {
      title: <FormattedMessage id="app.payment_gateway" defaultMessage={`Payment Gateway`}/>,
      dataIndex: "payment_gateway",
      key: "payment_gateway",
      align:"right",
      render:(payment_gateway) => PaymentGatewayOptions.find( item => item.value === payment_gateway)["label"]
    },
    {
      title: <FormattedMessage id="app.sum_amount" defaultMessage={`Total Amount`}/>,
      dataIndex: "sum_amount",
      key: "sum_amount",
      align:"center",
      render:(sum_amount) => getFormattedPrice(sum_amount)
    },
    {
      title: <FormattedMessage id="app.total_count" defaultMessage={`Total Count`}/>,
      dataIndex: "total",
      key: "total",
    },
    {
      title: "",
      key: "actions",
      align: "left",
      dataIndex: "actions",
      render: (text, record) => (
        <Tooltip title={<FormattedMessage id="app.report" defaultMessage={`Report`}/>}>
          <NavLink to={`/payments/gateways/${record.payment_gateway}/report`}>
            <Button type="link" size={`small`}>
              <Icon type="area-chart"/>
            </Button>
          </NavLink>
        </Tooltip>
      )
    }
  ];
  
  return (
    <Table
      className={'report-table'}
      columns={columns}
      loading={loading}
      pagination={false}
      dataSource={data}
      rowKey="id"
    />
  );
};

export default ReportList;
